"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import DiagramCard from "@/components/diagrams/DiagramCard";
import SinteredLayersDiagram from "@/components/diagrams/SinteredLayersDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
export default function ThreeLayerSinteredMeshPage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, COPY);
  const diagramCopy = {
    en: {
      sectionTitle: "3-Layer Sintered Wire Mesh Architecture",
      sectionLead: "Structural cross-section showing protective outer layer, fine filtration control layer, and rigid base support grid unified by vacuum diffusion bonding.",
      cardTitle: "3-Layer Structural Cross-Section",
      cardDesc: "L01 Protective Layer shields the L02 Filtration Control Layer, backed by the L03 Drainage and Support Skeleton with directional process flow."
    },
    zh: {
      sectionTitle: "3 层烧结丝网层析立体结构",
      sectionLead: "截面结构清晰展示外层防护网、微米控制网与粗目支撑骨架网经真空扩散焊接融合形成的高通量多孔介质。",
      cardTitle: "3 层复合截面与介质流向示意",
      cardDesc: "L01 表面保护层阻挡大颗粒冲击，L02 核心过滤层执行微米拦截，L03 骨架层提供刚性支撑与通流通道。"
    },
    es: {
      sectionTitle: "Arquitectura de malla sinterizada de 3 capas",
      sectionLead: "Corte estructural que ilustra la capa exterior protectora, la capa de control de precisión y la rejilla base de soporte unidas por difusión térmica.",
      cardTitle: "Esquema en corte de 3 capas",
      cardDesc: "La capa L01 resguarda la capa de control L02, sostenida por el esqueleto de soporte L03 con flujo direccional."
    },
    de: {
      sectionTitle: "Architektur des 3-lagigen Sintergewebes",
      sectionLead: "Struktureller Querschnitt mit äußerer Schutzlage, präziser Filterkontrollschicht und tragendem Stützgitter, diffusionsgebunden im Vakuum.",
      cardTitle: "3-Lagen-Strukturquerschnitt",
      cardDesc: "L01 Schutzschicht bewahrt die L02 Filterkontrollschicht, abgestützt durch das L03 Stütz- und Drainageskelett."
    },
    fr: {
      sectionTitle: "Architecture de la toile frittée 3 couches",
      sectionLead: "Coupe transversale illustrant la couche protectrice externe, la couche de contrôle micrométrique et la grille de support unies par diffusion sous vide.",
      cardTitle: "Schéma structurel 3 couches",
      cardDesc: "La couche de protection L01 préserve le contrôle L02, soutenu par l'ossature L03 assurant le drainage sous flux régulier."
    },
    pt: {
      sectionTitle: "Arquitetura da malha sinterizada de 3 camadas",
      sectionLead: "Corte estrutural ilustrando a camada externa de proteção, a camada de controle micrométrico e a tela de suporte unidas por difusão a vácuo.",
      cardTitle: "Esquema em corte de 3 camadas",
      cardDesc: "A camada L01 protege a camada de controle L02, apoiada pelo esqueleto L03 de drenagem e sustentação sob fluxo contínuo."
    }
  };
  const d = pick(lang, diagramCopy);
  const diagram = <DiagramSection id="three-layer-diagram" title={d.sectionTitle} lead={d.sectionLead} tone="background">
      <div className="max-w-3xl mx-auto">
        <DiagramCard index="SWM-3L" badge="3-Layer Matrix" title={d.cardTitle} description={d.cardDesc}>
          <SinteredLayersDiagram variant="three" />
        </DiagramCard>
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagram} />;
}